import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { HttpResponse, Requisition } from "@/types";

export function useDeleteRequisition() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async ({ requisitionId }: { requisitionId: number }) => {
      const path = `jobs/${currentJobId}/requisitions/${requisitionId.toString()}`;
      const res = await guacHttpClient.delete<
        Requisition,
        HttpResponse<Requisition>
      >(path);

      return res.data;
    },
    onSuccess: () => {
      // Invalidate queries that have job intake
      void queryClient.invalidateQueries({
        queryKey: ["jobs", currentCompanyId],
      });
    },
  });

  return mutation;
}
